import request, { IWorkspaceResponse } from '../http/Xrequest '
import { encryptPathSegment } from '../rsa/api-crypto'

// 告警流程详情
export const getAlarmProcessDetails = async function (id: string): Promise<IWorkspaceResponse<any>> {
  const url = `/alarm/process-detail/${id}`
  const result = await request.get(url)
  return result.data
}

// 转交其他飞手
export const getForwardAnotherFlyer = async function (id: string, params): Promise<IWorkspaceResponse<any>> {
  const url = `/alarm/process-detail/${id}`
  const result = await request.post(url, params)
  return result.data
}

// 根据业务id获取日志 单兵通知
export const getIndiNoticeRecord = async function (businessId: string): Promise<IWorkspaceResponse<any>> {
  const url = `/notice-log/get-by-business-id/${businessId}`
  const result = await request.get(url)
  return result.data
}

// 查询识别物体列表
export const listAllObject = async function (params: {}): Promise<IWorkspaceResponse<any>> {
  let url = '/business/object/list?' + encryptPathSegment(tansParams(params))
  url = url.slice(0, -1)
  const result = await request.get(url)
  return result.data
}

export function tansParams (params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName]
    const part = encodeURIComponent(propName) + '='
    if (value !== null && value !== '' && typeof (value) !== 'undefined') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== '' && typeof (value[key]) !== 'undefined') {
            const params = propName + '[' + key + ']'
            const subPart = encodeURIComponent(params) + '='
            result += subPart + encodeURIComponent(value[key]) + '&'
          }
        }
      } else {
        result += part + encodeURIComponent(value) + '&'
      }
    }
  }
  return result
}

// 修改识别物体
export const editListAllObject = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/business/object/edit'
  const result = await request.post(url, body)
  return result.data
}

// 新增识别物体
export const addListAllObject = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/business/object/add'
  const result = await request.post(url, body)
  return result.data
}

// 删除识别物体
export const delListAllObject = async function (ids): Promise<IWorkspaceResponse<any>> {
  const url = `/business/object/remove/${ids}`
  const result = await request.get(url)
  return result.data
}

// 获取识别物体详细信息
export const getListAllObject = async function (id): Promise<IWorkspaceResponse<any>> {
  const url = `/business/object/getInfo/${id}`
  const result = await request.get(url)
  return result.data
}

// 导出识别物体列表
export const exportListAllObject = async function (params): Promise<IWorkspaceResponse<any>> {
  const url = '/business/object/export'
  const result = await request.post(url, params, { responseType: 'blob' })
  return result.data
}

// 告警编辑
export const getEditAlarmMessage = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/alarm/edit-alarm'
  const result = await request.post(url, body)
  return result.data
}

// 标记告警
export const getAlarmMark = async function (id, isMark): Promise<IWorkspaceResponse<any>> {
  const url = `/alarm/mark-alarm/${id}/${isMark}`
  const result = await request.get(url)
  return result.data
}

// 上传媒体文件并识别（大模型）
export const getUploadFileAndAnalysis = async function (params): Promise<IWorkspaceResponse<any>> {
  const url = '/external-image/upload-file-and-analysis'
  const result = await request.post(url, params)
  return result.data
}

// 获取条例
export const getAcquisitionRegulations = async function (body): Promise<IWorkspaceResponse<any>> {
  const url = '/external-image/get-specification'
  const result = await request.post(url, body)
  return result.data
}

// 查询告警情况列表
export const getAlarmSituationList = async function (body): Promise<IWorkspaceResponse<any>> {
  const url = '/alarm-situation/list'
  const result = await request.post(url, body)
  return result.data
}

// 告警忽略
export const getAlarmIgnore = async function (id, alarmSituation, alarmSituationId): Promise<IWorkspaceResponse<any>> {
  const url = `/alarm/ignore-alarm/${id}`
  const result = await request.get(url, { params: { alarmSituation, alarmSituationId } })
  return result.data
}

// 告警图片大模型识别分析
export const getAlarmModelAnalysis = async function (param): Promise<IWorkspaceResponse<any>> {
  const url = '/files/upload-file-and-analysis'
  const result = await request.post(url, param)
  return result.data
}

// 告警websocket未读数量
export const getAlarmUnreadCount = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/websocket-log/user-count'
  const result = await request.post(url)
  return result.data
}

// 分页查询外部接口日志
export const getAlarmUnreadPage = async function (body): Promise<IWorkspaceResponse<any>> {
  const url = '/websocket-log/page'
  const result = await request.post(url, body)
  return result.data
}

// 单条已读
export const getAlarmUnreadRead = async function (id): Promise<IWorkspaceResponse<any>> {
  const url = `/websocket-log/do-view/${id}`
  const result = await request.post(url)
  return result.data
}

// 一键已读
export const getAlarmAllUnreadRead = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/websocket-log/do-view-all'
  const result = await request.post(url)
  return result.data
}

// 设备列表
export const getDeviceList = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/device/device-list'
  const result = await request.post(url, body)
  return result.data
}

// 直接导出PDF报表-不校验参数
export const exportPdfForNoCheck = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/report-templates/export-pdf-for-no-check'
  const result = await request.post(url, body, { responseType: 'blob' })
  return result.data
}

// 验证是否为blob格式
export async function blobValidate (data) {
  try {
    const text = await data.text()
    JSON.parse(text)
    return false
  } catch (error) {
    return true
  }
}
